import { memo } from 'react';

/** @public */
export const DummyPageOverlay = memo(({ pageId }: { pageId: number }) => {
  // oxlint-disable-next-line no-console
  console.log(`DummyPageOverlay rerender: page ${pageId}`);

  return (
    <g>
      <circle cx={50} cy={50} r={20} fill="lime" opacity={0.5} />
      <text x={50} y={55} fill="black" fontSize={10} textAnchor="middle">
        Overlay
      </text>
    </g>
  );
});
